import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
// form
import _Button from "../../../components/generic/_Button";
import { FileUpload } from "../../contacts/components";
import Stepper from "./Stepper";
import { useForm } from "../hooks";

const _ModalUploadFile = (props) => {
  /*eslint-disable-next-line*/
  const { visible, onClose, title, data = null, onRefresh } = props;

  const { formik, _onClose, fileUploadState, stepData, _onReset } = useForm({
    onClose,
    onRefresh,
  });

  return (
    <Modal show={visible} onHide={_onClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stepper step={formik.values.step} />
        <div className="border rounded-lg px-4 py-2 my-1">
          <FileUpload
            formik={formik}
            fileUploadState={fileUploadState}
            stepData={stepData}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <_Button style="primary" title="Limpiar" onClick={() => _onReset()} />
        <_Button style="none" title="Cancelar" onClick={_onClose} />
      </Modal.Footer>
    </Modal>
  );
};

_ModalUploadFile.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  onRefresh: PropTypes.func,
};
export default _ModalUploadFile;
